module.exports = __webpack_public_path__ + "static/media/sample-kit2.28d0db14.jpg";